import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import AcademyConfigProp from './propTypes/academyConfig';
import CourseProp from '../academy/propTypes/courseProp';
import Highlight from './Highlight';
import Anchor from '../../commonComponents/Anchor';
import { ENROLL_SOURCE } from '../../services/googleAnalytics';

function Highlights({ t, academyConfig, highlights }) {
  return (
    <div className="selling">
      {highlights && highlights.length > 0 ? (
        <div className="highlighted-courses">
          <div className="highlighted-courses-header">
            <h2 className="highlighted-courses-title">
              {t('landing_highlightedCourses')}
            </h2>
            <Anchor href="/academy" className="highlighted-courses-link">
              {t('landing_seeAllCourses')}
            </Anchor>
          </div>
          <hr className="divider-black" />
          <div className="highlighted-courses-row row">
            {highlights.slice(0, 4).map(course => (
              <div
                key={course._id}
                className="academy-row-item col-12 col-lg-3 col-md-3 "
              >
                <Highlight
                  source={ENROLL_SOURCE.MAIN}
                  course={course}
                  academyConfig={academyConfig}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

Highlights.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
  highlights: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType))
    .isRequired,
};

export default translate(Highlights);
